import { render, staticRenderFns } from "./PrescripteurSelection.vue?vue&type=template&id=215360b4&scoped=true"
import script from "./PrescripteurSelection.vue?vue&type=script&lang=js"
export * from "./PrescripteurSelection.vue?vue&type=script&lang=js"
import style0 from "./PrescripteurSelection.vue?vue&type=style&index=0&id=215360b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215360b4",
  null
  
)

export default component.exports